/**
 * Maps Site Builder book section `background_color` / `background_effect` to theme classes
 * (same rules as other CMS-driven sections, e.g. About statistics).
 */
export function getBookSectionSurfaceClasses(backgroundColor, backgroundEffect) {
  const bgColor = backgroundColor || 'light';
  const effect = backgroundEffect || null;

  // `gray` matches public list bands (`.excursions-results-section` / `.car-rental-fleet-section` use `bg-light`).
  let bgClass =
    bgColor === 'primary'
      ? 'section-bg-primary'
      : bgColor === 'white'
        ? 'bg-white'
        : bgColor === 'dark'
          ? 'bg-dark text-white'
          : bgColor === 'gray' || bgColor === 'light'
            ? 'bg-light'
            : 'bg-light';

  if (bgColor === 'primary' && effect === 'gradient') {
    bgClass = 'section-bg-primary-gradient';
  }

  const hasDotsEffect = bgColor === 'primary' && effect === 'dots';
  const hasPatternEffect = effect === 'pattern';
  const needsOverflow = hasDotsEffect || hasPatternEffect;

  const extra = [needsOverflow ? 'position-relative overflow-hidden' : '', hasPatternEffect ? 'section-bg-pattern' : '']
    .filter(Boolean)
    .join(' ');

  return {
    sectionClassNames: [bgClass, extra].filter(Boolean).join(' ').trim(),
    hasDotsEffect,
  };
}
